import React from 'react'
import CentresContainers from '../containers/Centres'
import ConfigurationContainer from '../containers/Configuration'

const Configuration = () => {
  return (
    <div>
      <ConfigurationContainer/>
    </div>
  )
}

export default Configuration
